import { useFormStage } from 'BreetHooks';
import {
	closeModals,
	selectModals,
	selectTransactionSellServicesById,
	useAppDispatch,
	useAppSelector,
	useGetMarketAssetConverterQuery,
} from 'BreetRedux';
import { useCallback } from 'react';

import { Loader } from '../Loader';
import ModalParts from '../ModalParts';
import MenuSelection from './components/MenuSelection';
import PayResolutionFee from './components/PayResolutionFee';
import TopUpMinimum from './components/TopUpMinimum';
import { type RESOLVETRADESTAGE } from './DialogResolveTrade.helpers';

const DialogResolveTrade = () => {
	const { isStageActive, navigator } = useFormStage<RESOLVETRADESTAGE>('menuSelection', [
		'topUpMinimum',
		'menuSelection',
		'payResolutionFee',
	]);

	const dispatch = useAppDispatch();

	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'resolveTrade');

	const transactionIdObject = modal?.metadata as { transactionId: string };

	const transactionApiData = useAppSelector(selectTransactionSellServicesById(transactionIdObject.transactionId));

	const transaction = transactionApiData.data?.data;

	const assetSymbol = transaction?.doc.assetDoc.legacyTicker ?? '';

	const { data: marketAssetConverterData, isLoading } = useGetMarketAssetConverterQuery(
		{ to: 'usd', from: assetSymbol },
		{ skip: !assetSymbol }
	);

	const exitModals = useCallback(() => {
		dispatch(closeModals());
	}, [dispatch]);

	const minimumValue = (transaction?.doc.balanceRemaining ?? 0) / (marketAssetConverterData?.data?.quote.USD.price ?? 0);

	if (isLoading)
		return (
			<div className='modal-loader bg-neutral-50'>
				<Loader />
			</div>
		);

	return (
		<ModalParts.Wrapper wrapperClassName='resolvetrade bg-primary-600'>
			<ModalParts.Stage hide={!isStageActive('menuSelection')}>
				<MenuSelection
					onPayResolutionFees={navigator.goTo('payResolutionFee')}
					onTopUpMinimum={navigator.goTo('topUpMinimum')}
					minimumValue={minimumValue}
					assetSymbol={assetSymbol}
					resolutionFee={transaction?.doc.flagFeeUSD ?? 0}
				/>
			</ModalParts.Stage>

			<ModalParts.Stage hide={!isStageActive('topUpMinimum')}>
				<TopUpMinimum
					onBackLink={navigator.goTo('menuSelection')}
					minimumValue={minimumValue}
					assetSymbol={assetSymbol}
					avatar={transaction?.doc.avatar ?? ''}
					assetName={transaction?.doc.identifier ?? ''}
					walletAddress={transaction?.doc.address ?? ''}
					onExitModal={exitModals}
				/>
			</ModalParts.Stage>

			<ModalParts.Stage hide={!isStageActive('payResolutionFee')}>
				<PayResolutionFee
					onBackLink={navigator.goTo('menuSelection')}
					resolutionFee={transaction?.doc.flagFeeUSD ?? 0}
					transactionId={transaction?.doc._id ?? ''}
					exitModals={exitModals}
				/>
			</ModalParts.Stage>
		</ModalParts.Wrapper>
	);
};

export default DialogResolveTrade;
